import { Analytics } from './analytics';
import { VariationAction } from '../../../variations/actions/variation_action';

export class ReviewCardAnalytics extends Analytics {
  constructor() {
    super();
    VariationAction.REVIEW_CARD_EVENT.on((data) => {
      this.run(() => {
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: 'レビューの続きを見る_バリエーション',
          club: {
            server: 'club/pc',
            prop5: 'レビューの続きを見る_バリエーション'
          }
        };
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', 'clkShowDetailReviewVariation');
      });
    });
  }
}
